import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    TextField,
    Button,
    Typography,
    Grid,
    FormControlLabel,
    Switch,
    Divider,
    MenuItem,
    Modal,
    Box,
    IconButton,
    Paper,
    Snackbar
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PlusIcon from '@mui/icons-material/Add';
import addIcon from '../../assets/icons/add.svg';
import eyeIcon from '../../assets/icons/eye.svg';
import binIcon from '../../assets/icons/bin.svg';
import { useNavigate } from 'react-router-dom';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
var constants = require('../../constant');

// Modal style for viewing the image
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#65C466',
                opacity: 1,
                border: 0,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 13,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

const AddVehicle = ({ onClose, editMode = false, vehicleData = {} }) => {

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    
    const clientId = localStorage.getItem('clientId');
    const token = localStorage.getItem('token');
    const [vehicleId, setvehicleId] = useState('');
    const [vehicleName, setVehicleName] = useState('');
    const [displayOrder, setDisplayOrder] = useState('');
    const [seats, setSeats] = useState('');
    const [enabled, setEnabled] = useState(true);
    const [documents, setDocuments] = useState([{ name: '', type: '', images: 1, required: false, docNumberRequired: false }]);
    const [images, setImages] = useState([]);
    const [open, setOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);
    const [city, setCity] = useState('');
    const [vehicleType, setVehicleType] = useState('');
    const [fareId, setfareId] = useState('');
    const [baseFare, setBaseFare] = useState('');
    const [minimumFare, setMinimumFare] = useState('');
    const [thresholds, setThresholds] = useState([{ price: '', distance: '' }]);
    const [isFareModified, setIsFareModified] = useState(false);
    const [commissionPercentage, setCommissionPercentage] = useState('');
    const [commissionThreshold, setCommissionThreshold] = useState('');
    const [fixedCommission, setFixedCommission] = useState('');
    const [requestRadiusThreshold, setRequestRadiusThreshold] = useState(''); // Stores the threshold radius
    const [initialRequestRadius, setInitialRequestRadius] = useState(''); // Stores the initial request radius
    const [requestRadiusHop, setRequestRadiusHop] = useState(''); // Stores the hop/increment value
    const [convenienceCharge, setConvenienceCharge] = useState(''); // Convenience Charge value
    const [convenienceDriverCut, setConvenienceDriverCut] = useState('');
    const [minDriverBalance, setMinDriverBalance] = useState(''); // Minimum Driver Balance value
    const [platformFee, setPlatformFee] = useState('');
    const [taxName, setTaxName] = useState('');
    const [taxPercentage, setTaxPercentage] = useState('');
    const [timeBaseFare, setTimeBaseFare] = useState('');
    const [minimumTimeFare, setMinimumTimeFare] = useState('');
    const [timeThresholds, setTimeThresholds] = useState([{ timePrice: '', time: '' }]);
    const [waitingChangesWindow, setWaitingChangesWindow] = useState('');
    const [pickupDistanceWindow, setPickupDistanceWindow] = useState('');
    const [waitingThresholds, setWaitingThresholds] = useState([{ minDist:'', maxDist: '', charge: '', driverCut: '' }]);
    const [luggageChargesDriverCut, setLuggageChargesDriverCut] = useState('');
    const [luggageCharges, setLuggageCharges] = useState('');
    const [pickupThresholds, setPickupThresholds] = useState([{pickupMinDist: '', pickupMaxDist: '', pickupCharge: '', pickupDriverCut:''}])

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [initialData, setInitialData] = useState({});

    // State for Snackbar
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    // Assuming client_cities is stored in local storage as a JSON string
    const clientCities = JSON.parse(localStorage.getItem("cities")) || [];
    const navigate = useNavigate();

    // Populate form fields when in Edit mode with provided data
    useEffect(() => {
        console.log('vehicleData = ', vehicleData);
        if (editMode && vehicleData) {
            setvehicleId(vehicleData.vehicle_id || '');
            setVehicleName(vehicleData.vehicle_name || '');
            setDisplayOrder(vehicleData.display_order || '');
            setSeats(vehicleData.seat_count || '');
            setEnabled(vehicleData.is_active === 1);
            setCity(vehicleData.city_name || '');
            setVehicleType(constants.VehicleTypes[Number(vehicleData.vehicle_type)] || 'Unknown');

            if (vehicleData.vehicle_image) {
                setImages([{ src: vehicleData.vehicle_image, name: 'Existing Image', isUploaded: true }]);
            } else {
                setImages([]);
            }

            if (vehicleData.vehicle_docs && vehicleData.vehicle_docs.length > 0) {
                const formattedDocs = vehicleData.vehicle_docs.map((doc) => ({
                    docId: doc.document_id,
                    name: doc.document_name,
                    type: doc.document_type === 1 ? 'Image' : 'Other',
                    images: doc.no_of_images,
                    required: doc.is_required === 1,
                    docNumberRequired: doc.is_doc_number_required === 1,
                }));
                setDocuments(formattedDocs);
            } else {
                setDocuments([{ name: '', type: '', images: 1, required: false, docNumberRequired: false }]);
            }

            if (vehicleData.vehicle_fare && vehicleData.vehicle_fare.length > 0) {
                const fareData = vehicleData.vehicle_fare[0];
                setBaseFare(fareData.base_fare || '');
                setMinimumFare(fareData.minimum_fare || '');
                setfareId(fareData.fare_id || '');
                setTimeBaseFare(fareData.time_base_fare || '');
                setMinimumTimeFare(fareData.time_minimum_fare || '');
                setLuggageCharges(fareData.luggage_charges || 0);
                setLuggageChargesDriverCut(fareData.luggage_charges_driver_cut || 0);
                setPickupDistanceWindow(fareData.pickup_distance_window || 0);
                setWaitingChangesWindow(fareData.waiting_charges_window || 0);

                if (fareData.fare_thresholds) {
                    const thresholdArray = Object.entries(fareData.fare_thresholds).map(([distance, price]) => ({
                        distance: parseInt(distance),
                        price: parseFloat(price),
                    }));
                    setThresholds(thresholdArray);
                } else {
                    setThresholds([{ distance: '', price: '' }]);
                }

                if (fareData.time_fare_thresholds) {
                    const thresholdArray = Object.entries(fareData.time_fare_thresholds).map(([time, timePrice]) => ({
                        time: parseInt(time),
                        timePrice: parseFloat(timePrice),
                    }));
                    setTimeThresholds(thresholdArray);
                } else {
                    setTimeThresholds([{ time: '', timePrice: '' }]);
                }

                if (fareData.pickup_distance_charges_thr) {
                    const thresholdArray = Object.entries(fareData.pickup_distance_charges_thr).map(([key, val]) => ({
                        pickupMaxDist: parseInt(key),
                        pickupCharge: parseInt(val.charge),
                        pickupDriverCut: parseInt(val.driver_cut)
                    }));

                    const updatedThresholdArray = thresholdArray.reduce((result, current, index) => {
                        if (index === 0) {
                            // For the first object, set pickupMinDist to 0
                            result.push({ ...current, pickupMinDist: fareData.pickup_distance_window+1 });
                        } else {
                            // For subsequent objects, set pickupMinDist to pickupMaxDist + 1 of the previous object
                            const prev = result[result.length - 1];
                            result.push({ ...current, pickupMinDist: prev.pickupMaxDist + 1 });
                        }
                        return result;
                    }, []);

                    setPickupThresholds(updatedThresholdArray);
                } else {
                    setPickupThresholds([{pickupMinDist: '', pickupMaxDist: '', pickupCharge: '', pickupDriverCut:''}]);
                }


                if (fareData.waiting_charges_thresholds) {
                    const thresholdArray = Object.entries(fareData.waiting_charges_thresholds).map(([key, val]) => ({
                        maxDist: parseInt(key),
                        charge: parseInt(val.charge),
                        driverCut: parseInt(val.driver_cut)
                    }));

                    const updatedThresholdArray = thresholdArray.reduce((result, current, index) => {
                        if (index === 0) {
                            // For the first object, set pickupMinDist to 0
                            result.push({ ...current, minDist: fareData.waiting_charges_window+1 });
                        } else {
                            // For subsequent objects, set pickupMinDist to pickupMaxDist + 1 of the previous object
                            const prev = result[result.length - 1];
                            result.push({ ...current, minDist: prev.maxDist + 1 });
                        }
                        return result;
                    }, []);

                    setWaitingThresholds(updatedThresholdArray);
                } else {
                    setWaitingThresholds([{minDist: '', maxDist: '', charge: '', driverCut:''}]);
                }
            }

            setCommissionPercentage(vehicleData.commission_percentage || '');
            setCommissionThreshold(vehicleData.commission_threshold || '');
            setFixedCommission(vehicleData.fixed_commission || '');

            setRequestRadiusThreshold(vehicleData.request_radius_threshold || '');
            setInitialRequestRadius(vehicleData.initial_request_radius || '');
            setRequestRadiusHop(vehicleData.request_radius_hop || '');

            setConvenienceCharge(vehicleData.convenience_charge || '');
            setMinDriverBalance(vehicleData.min_driver_balance || '');
            setConvenienceDriverCut(vehicleData.convenience_driver_cut || '');
            setPlatformFee(vehicleData.platform_fee || '');
            setTaxName(vehicleData.tax_name || '');
            setTaxPercentage(vehicleData.tax_percentage || '');

            setInitialData({
                vehicle_name: vehicleData.vehicle_name || '',
                display_order: vehicleData.display_order || '',
                seat_count: vehicleData.seat_count || '',
                is_active: vehicleData.is_active === 1,
                city_name: vehicleData.city_name || '',
                vehicle_type: constants.VehicleTypes[Number(vehicleData.vehicle_type)] || 'Unknown',
                vehicle_image: vehicleData.vehicle_image || null,
                commission_percentage: vehicleData.commission_percentage || '',
                commission_threshold: vehicleData.commission_threshold || '',
                fixed_commission: vehicleData.fixed_commission || '',
                request_radius_threshold: vehicleData.request_radius_threshold || '',
                initial_request_radius: vehicleData.initial_request_radius || '',
                request_radius_hop: vehicleData.request_radius_hop || '',
                waiting_time_threshold: vehicleData.waiting_time_threshold || '',
                waiting_charges: vehicleData.waiting_charges || '',
                convenience_charge: vehicleData.convenience_charge || '',
                min_driver_balance: vehicleData.min_driver_balance || '',
                convenience_driver_cut: vehicleData.convenience_driver_cut || '',
                platform_fee: vehicleData.platform_fee || '',
                tax_name: vehicleData.tax_name || '',
                tax_percentage: vehicleData.tax_percentage || ''
            });
        }
    }, [editMode, vehicleData]);

    const handleAddImage = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const formData = new FormData();
            formData.append('image', file);
    
            try {
                const response = await axios.post(operationsUrl + '/upload_image', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
    
                const s3Url = response.data.url;
                const newImage = {
                    name: file.name,
                    src: s3Url,
                    isUploaded: true,
                };
    
                setImages([newImage]); // Restrict to one image
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }
    };
    
    const handleDeleteImage = async (index) => {
        const imageToDelete = images[index];
        if (!imageToDelete || !imageToDelete.src) {
            console.error('No image to delete');
            return;
        }

        try {
            await axios.delete(operationsUrl + '/delete_image', {
                data: {
                    url: imageToDelete.src, // Pass the S3 URL here
                },
            });

            // Send an update request to clear the vehicle_image key in the database
            const updateData = {
                token: token,
                vehicle_id: vehicleId,
                vehicle_image: '',
            };

            await axios.post(operationsUrl + '/update_client_vehicle_type', updateData);

            // Update the local state after successful deletion
            setImages([]);
            window.location.reload();
        } catch (error) {
            console.error('Error deleting image:', error);
        }
    };          

    const handleViewImage = (image) => {
        setCurrentImage(image);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentImage(null);
    };

    const handleUpdateDocument = async (index) => {
        const doc = documents[index];
        const documentData = {
            token: token,
            document_id: doc.docId, // Use docId for update
            document_name: doc.name,
            document_type: doc.type === 'Image' ? 1 : 2,
            no_of_images: doc.images,
            is_doc_number_required: doc.docNumberRequired ? 1 : 0,
            is_required: doc.required ? 1 : 0,
            is_active: 1,
        };
    
        try {
            await axios.post(operationsUrl + '/update_vehicle_documents', documentData);
            const updatedDocuments = [...documents];
            updatedDocuments[index].isModified = false; // Reset modified state
            setDocuments(updatedDocuments);
        } catch (error) {
            console.error('Error updating document:', error);
        }
    };
    
    const handleDeleteDocument = async (index) => {
        const doc = documents[index];
        if (!doc.docId) return; // Skip if there's no docId
    
        try {
            await axios.post(operationsUrl + '/update_vehicle_documents', {
                token: token,
                document_id: doc.docId,
                is_active: 0, // Mark document as inactive
            });
            const updatedDocuments = documents.filter((_, i) => i !== index);
            setDocuments(updatedDocuments);
        } catch (error) {
            console.error('Error deleting document:', error);
        }
    };    

    const handleDocumentChange = (index, field, value) => {
        const updatedDocuments = [...documents];
        updatedDocuments[index][field] = value;
    
        // Mark as modified only if it already exists in the database
        if (updatedDocuments[index].docId) {
            updatedDocuments[index].isModified = true;
        }
    
        setDocuments(updatedDocuments);
    };

    const handleSaveNewDocument = async (index) => {
        const doc = documents[index];
        const documentData = {
            token: token,
            document_name: doc.name,
            vehicle_id: vehicleId,
            city_id: clientCities.find((cityObj) => cityObj.city_name === city)?.city_id || '',
            client_id: clientId,
            document_type: doc.type === 'Image' ? 1 : 2,
            no_of_images: doc.images,
            is_doc_number_required: doc.docNumberRequired ? 1 : 0,
            is_required: doc.required ? 1 : 0,
            is_active: 1,
        };
    
        try {
            const response = await axios.post(operationsUrl + '/insert_vehicle_documents', documentData);
    
            if(response.data.flag==102){
                console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    console.log('toke====.....==== ', token);
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
            }
            if (response.data.flag === 200 && response.data.document_id) {
                setDocuments((prevDocuments) => {
                    const updatedDocuments = [...prevDocuments];
                    updatedDocuments[index] = {
                        ...doc,
                        docId: response.data.document_id, // Use the returned document_id
                        isModified: false, // Reset modified state
                    };
                    return updatedDocuments;
                });
            } else {
                console.error('Failed to save document:', response.data.message);
            }
        } catch (error) {
            console.error('Error saving new document:', error);
        }
    };
    
    const getUpdatedFields = () => {
        const updatedFields = {};
    
        if (initialData.vehicle_name !== vehicleName) {
            updatedFields.vehicle_name = vehicleName;
        }
        if (initialData.display_order !== displayOrder) {
            updatedFields.display_order = displayOrder;
        }
        if (initialData.seat_count !== seats) {
            updatedFields.seat_count = seats;
        }
        if (initialData.is_active !== enabled) {
            updatedFields.is_active = enabled ? 1 : 0;
        }
        if (initialData.city_name !== city) {
            updatedFields.city_id = clientCities.find((cityObj) => cityObj.city_name === city)?.city_id || '';
        }
        if (initialData.vehicle_type !== vehicleType) {
            updatedFields.vehicle_type = Object.entries(constants.VehicleTypes).find(([key, value]) => value === vehicleType)?.[0] || null;
        }
        if (initialData.vehicle_image !== (images.length > 0 ? images[0].src : null)) {
            updatedFields.vehicle_image = images.length > 0 ? images[0].src : undefined;
        }

        if (commissionPercentage !== initialData.commission_percentage) {
            updatedFields.commission_percentage = parseInt(commissionPercentage);
        }
        if (commissionThreshold !== initialData.commission_threshold) {
            updatedFields.commission_threshold = parseInt(commissionThreshold);
        }
        if (fixedCommission !== initialData.fixed_commission) {
            updatedFields.fixed_commission = parseInt(fixedCommission);
        }

        if (requestRadiusThreshold !== initialData.request_radius_threshold) {
            updatedFields.request_radius_threshold = parseInt(requestRadiusThreshold);
        }
        if (initialRequestRadius !== initialData.initial_request_radius) {
            updatedFields.initial_request_radius = parseInt(initialRequestRadius);
        }
        if (requestRadiusHop !== initialData.request_radius_hop) {
            updatedFields.request_radius_hop = parseInt(requestRadiusHop);
        }

        // Convenience charge
        if (convenienceCharge !== initialData.convenience_charge) {
            updatedFields.convenience_charge = parseInt(convenienceCharge);
        }

        // Minimum driver balance
        if (minDriverBalance !== initialData.min_driver_balance) {
            updatedFields.min_driver_balance = parseInt(minDriverBalance);
        }

        if(convenienceDriverCut != initialData.convenience_driver_cut) {
            updatedFields.convenience_driver_cut = parseInt(convenienceDriverCut);
        }
        if(platformFee != initialData.platform_fee){
            updatedFields.platform_fee = parseInt(platformFee);
        }
        if(taxName != initialData.tax_name) {
            updatedFields.tax_name = taxName;
        }
        if(taxPercentage != initialData.tax_percentage){
            updatedFields.tax_percentage = taxPercentage;
        }
    
        return updatedFields;
    };
    
    // Function to handle saving the vehicle
    const handleSubmit = async () => {
        const updatedFields = getUpdatedFields();
        
        if (Object.keys(updatedFields).length === 0) {
            console.log('No changes to update');
            return; // No changes, no need to call the API
        }
    
        // Add token and other required fields
        updatedFields.token = token;
        updatedFields.client_id = clientId;
    
        if (vehicleId) {
            // Update existing vehicle
            updatedFields.vehicle_id = vehicleId; // Mandatory vehicle_id for updates
    
            try {
                const response = await axios.post(operationsUrl + '/update_client_vehicle_type', updatedFields);
                if(response.data.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    console.log('toke====.....==== ', token);
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                }
                if (response.data.flag === 200) {
                    window.location.reload();
                }
                 else {
                    console.error('Failed to update vehicle:', response.data.message);
                }
            } catch (error) {
                console.error('Error submitting vehicle form:', error);
            }
        } else {
            // Create a new vehicle
            try {
                const response = await axios.post(operationsUrl + '/create_client_vehicle_type', updatedFields);
                
                if(response.data.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    console.log('toke====.....==== ', token);
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                }

                if (response.data.flag === 200) {
                    setSnackbarMessage('Vehicle updated successfully!');
                    setOpenSnackbar(true);
                    window.location.reload();
                } else {
                    console.error('Failed to create vehicle:', response.data.message);
                    setSnackbarMessage('Failed to update vehicle. Please try again.');
                    setOpenSnackbar(true);
                }
            } catch (error) {
                console.error('Error submitting vehicle form:', error);
                setSnackbarMessage('Error updating vehicle. Please try again.');
                setOpenSnackbar(true);
            }
        }
    
        onClose(); // Close modal if needed
    };

    const handleSaveFareSettings = async () => {

        if (thresholds.length > 0) {
            const fareThresholds = thresholds.reduce((acc, curr) => {
                acc[curr.distance] = curr.price;
                return acc;
            }, {});
            if(timeThresholds.length > 0){
                var timeThreshold = timeThresholds.reduce((acc, curr) => {
                    acc[curr.time] = curr.timePrice;
                    return acc;
                }, {});
            }

            if(waitingThresholds.length > 0){
                var waitingThreshold = waitingThresholds.reduce((acc, curr) => {
                    acc[curr.maxDist]={
                        charge: curr.charge,
                        driver_cut: curr.driverCut
                    }
                    return acc;
                }, {});
            }

            if(pickupThresholds.length > 0){
                console.log('pickup thresholds = ', pickupThresholds)
                var pickupThreshold = pickupThresholds.reduce((acc, curr) => {
                    acc[curr.pickupMaxDist]={
                        charge: curr.pickupCharge,
                        driver_cut: curr.pickupDriverCut
                    }
                    return acc;
                }, {});
            }
    
            const fareData = {
                token: token,
                fare_id: fareId || undefined, // Include fareId only if it exists
                clt_vehicle_id: vehicleId
            };
            if(pickupThresholds[0].pickupMaxDist!=''){
                fareData['pickup_distance_charges_thr'] = pickupThreshold;
            }
            if(luggageChargesDriverCut){
                fareData['luggage_charges_driver_cut'] = luggageChargesDriverCut;
            }
            if(luggageCharges){
                fareData['luggage_charges'] = luggageCharges;
            }
            if(waitingThresholds[0].minDist!=''){
                fareData['waiting_charges_thresholds'] = waitingThreshold;
            }
            if(minimumTimeFare){
                fareData['time_minimum_fare']=parseFloat(minimumTimeFare);
            }
            if(timeBaseFare){
                fareData['time_base_fare'] = parseFloat(timeBaseFare);
            }
            if(minimumFare){
                fareData['minimum_fare'] = parseFloat(minimumFare);
            }
            if(baseFare){
                fareData['base_fare'] = parseFloat(baseFare);
            }
            if(timeThresholds[0].time!=''){
                fareData['time_fare_thresholds'] = timeThreshold
            }
            if(thresholds[0].distance!=''){
                fareData['fare_thresholds'] = fareThresholds;
            }
            if(waitingChangesWindow){
                fareData['waiting_charges_window'] = waitingChangesWindow;
            }

            if(pickupDistanceWindow){
                fareData['pickup_distance_window'] = pickupDistanceWindow;
            }
            console.log('fare data = ', fareData)
    
            try {
                const response = await axios.post(operationsUrl + '/create_and_update_vehicle_fare', fareData);

                // Check if response is successful
                if (response.status === 200) {
                    setSnackbarMessage('Updated Successfully!');
                    setOpenSnackbar(true); // Show success message

                    // Update the local state with the new fare settings
                    setBaseFare(fareData.base_fare);
                    setMinimumFare(fareData.minimum_fare);
                
                }
            } catch (error) {
                console.error('Error saving fare settings:', error);
                setSnackbarMessage('Error updating fare settings');
                setOpenSnackbar(true); // Show error message
            }
        }
    };

    useEffect(() => {
        if (
            baseFare !== '' ||
            minimumFare !== '' ||
            thresholds.some(threshold => threshold.price !== '' || threshold.distance !== '')
        ) {
            setIsFareModified(true);
        } else {
            setIsFareModified(false);
        }
    }, [baseFare, minimumFare, thresholds]);

    const handleAddThreshold = () => {
        setThresholds([...thresholds, { price: '', distance: '' }]);
    };

    const handleAddTimeThreshold = () => {
        setTimeThresholds([...timeThresholds, { timePrice: '', time: '' }]);
    };

    const handleAddWaitingThreshold = () => {
        const lastMaxDist = waitingThresholds.length > 0 ? Number(waitingThresholds[waitingThresholds.length - 1].maxDist) : waitingChangesWindow;

        setWaitingThresholds([...waitingThresholds, { minDist: lastMaxDist + 1, maxDist: '', charge: '', driverCut:'' }]);
    };

    const handleAddPickupThreshold = () => {
        const lastMaxDist = pickupThresholds.length > 0 ? Number(pickupThresholds[pickupThresholds.length - 1].pickupMaxDist) : pickupDistanceWindow;

        setPickupThresholds([...pickupThresholds, { pickupMinDist: lastMaxDist+1, pickupMaxDist: '', pickupCharge: '', pickupDriverCut:'' }]);
    };

    const handleRemoveThreshold = (index) => {
        const updatedThresholds = thresholds.filter((_, i) => i !== index);
        setThresholds(updatedThresholds);
    };

    const handleRemoveTimeThreshold = (index) => {
        const updatedThresholds = timeThresholds.filter((_, i) => i !== index);
        setTimeThresholds(updatedThresholds);
    };

    const handleRemoveWaitingThreshold = (index) => {
        const updatedThresholds = waitingThresholds.filter((_, i) => i !== index);
        setWaitingThresholds(updatedThresholds);
    };

    const handleRemovePickupThreshold = (index) => {
        const updatedThresholds = pickupThresholds.filter((_, i) => i !== index);
        setPickupThresholds(updatedThresholds);
    };

    const handleThresholdChange = (index, field, value) => {
        const updatedThresholds = thresholds.map((threshold, i) =>
            i === index ? { ...threshold, [field]: value } : threshold
        );
        setThresholds(updatedThresholds);
    };

    const handleTimeThresholdChange = (index, field, value) => {
        const updatedThresholds = timeThresholds.map((threshold, i) =>
            i === index ? { ...threshold, [field]: value } : threshold
        );
        setTimeThresholds(updatedThresholds);
    };

    const handleWaitingThresholdChange = (index, field, value) => {
        const updatedThresholds = waitingThresholds.map((threshold, i) =>
            i === index ? { ...threshold, [field]: value } : threshold
        );
        setWaitingThresholds(updatedThresholds);
    };

    const handlePickupThresholdChange = (index, field, value) => {
        const updatedThresholds = pickupThresholds.map((threshold, i) =>
            i === index ? { ...threshold, [field]: value } : threshold
        );
        setPickupThresholds(updatedThresholds);
    };
    
    return (
        <div style={{ position: 'relative', padding: '40px 0' }}>
            {/* Close Button Outside the Card */}
            <IconButton aria-label="close" onClick={onClose}
                style={{position:'absolute', top:'-15px', left:'1px', color:'#333', zIndex:10}}
            >
                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
            </IconButton>

            {/* Main Card/Container */}
            <Paper elevation={3}
                style={{padding: '30px', maxWidth: '800px', margin: '0 auto',backgroundColor: '#FFFFFF',borderRadius: '12px'}}
            >

                {/* Vehicle Section */}
                {editMode && (
                    <div style={{
                        display: 'flex',alignItems: 'center',backgroundColor: '#fff',padding: '10px 20px',marginBottom: '20px',
                        border: '1px solid #E0E0E0',borderRadius: '8px',boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                    }}>
                        <Typography variant="body1" style={{ color: '#4A4A4A' }}>Vehicle</Typography>
                        <div style={{ display: 'flex', marginLeft: 'auto' }}>
                            <Button variant="contained" onClick={() => setEnabled(true)}
                                style={{
                                    backgroundColor: enabled ? '#0DBA78' : '#F4F4F4', minWidth: '80px',padding: '6px 16px',
                                    color:enabled?'#FFFFFF':'#9E9E9E',textTransform:'none',borderRadius:'8px 0 0 8px', boxShadow: 'none',
                                }}
                            >
                                Enable
                            </Button>
                            <Button variant="contained" onClick={() => setEnabled(false)}
                                style={{
                                    backgroundColor: !enabled ? '#D14545' : '#F4F4F4', color: !enabled ? '#FFFFFF' : '#9E9E9E',
                                    textTransform:'none', borderRadius:'0 8px 8px 0', boxShadow:'none',padding:'6px 16px', minWidth:'80px',
                                }}
                            >
                                Disable
                            </Button>
                        </div>
                    </div>
                )}

                {/* Heading */}
                <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                {editMode ? 'Edit Vehicle Type' : 'Add Vehicle Type'}
                </Typography>

                {/* Input Fields */}
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={<span>City <span style={{ color: 'red' }}>*</span></span>}
                            select fullWidth variant="outlined" value={city} onChange={(e) => setCity(e.target.value)}
                            InputProps={{
                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                                '& .MuiInputLabel-root': {fontSize: '16px'}
                            }}
                        >
                        {clientCities.map((cityObj) => (
                                <MenuItem key={cityObj.city_id} value={cityObj.city_name}>
                                    {cityObj.city_name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                        <TextField label={<span>Vehicle Name <span style={{ color: 'red' }}>*</span></span>}
                            fullWidth variant="outlined" value={vehicleName}
                            onChange={(e) => setVehicleName(e.target.value)}
                            InputProps={{
                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                                '& .MuiInputLabel-root': {fontSize: '16px'}
                            }}
                        />
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={<span>Vehicle Type <span style={{ color: 'red' }}>*</span></span>}
                            select
                            fullWidth
                            variant="outlined"
                            value={vehicleType}
                            onChange={(e) => setVehicleType(e.target.value)}
                            InputProps={{
                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                                '& .MuiInputLabel-root': {fontSize: '16px'},
                            }}
                        >
                            {Object.entries(constants.VehicleTypes).map(([id, label]) => (
                                <MenuItem key={id} value={label}>
                                    {label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={<span>Seats <span style={{ color: 'red' }}>*</span></span>}
                            fullWidth
                            variant="outlined"
                            value={seats}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                    setSeats(value);
                                }
                            }}
                            InputProps={{
                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                                '& .MuiInputLabel-root': {fontSize: '16px'}
                            }}
                        />
                    </Grid>

                    {/* Convenience Charge */}
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={<span>Convenience Charge <span style={{ color: 'red' }}>*</span></span>}
                            placeholder="Enter Convenience Charge"
                            fullWidth
                            variant="outlined"
                            type="number"
                            value={convenienceCharge}
                            onChange={(e) => setConvenienceCharge(e.target.value)}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {
                                    height: '56px',
                                    fontSize: '16px',
                                    padding: '8px 14px',
                                    backgroundColor: '#FFFFFF',
                                },
                            }}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#E0E0E0',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '16px',
                                },
                            }}
                        />
                    </Grid>

                    {/* Convenience Driver Cut */}
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={<span>Convenience Driver Cut <span style={{ color: 'red' }}>*</span></span>}
                            fullWidth
                            variant="outlined"
                            type="number"
                            value={convenienceDriverCut}
                            onChange={(e) => {
                                const value = Number(e.target.value);
                                if (value <= convenienceCharge) {
                                    setConvenienceDriverCut(value);
                                } else {
                                    alert(`Convenience Driver Cut cannot exceed ${convenienceCharge}`);
                                }
                            }}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {
                                    height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF',
                                },
                            }}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                                '& .MuiInputLabel-root': {fontSize: '16px'},
                            }}
                        />
                    </Grid>

                    {/* Min Driver Balance */}
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={<span>Min Driver Balance <span style={{ color: 'red' }}>*</span></span>}
                            fullWidth
                            variant="outlined"
                            type="number"
                            value={minDriverBalance}
                            onChange={(e) => setMinDriverBalance(e.target.value)}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {
                                    height: '56px',
                                    fontSize: '16px',
                                    padding: '8px 14px',
                                    backgroundColor: '#FFFFFF',
                                },
                            }}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#E0E0E0',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '16px',
                                },
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={<span>Display Order <span style={{ color: 'red' }}>*</span></span>}
                            placeholder="0"
                            fullWidth
                            variant="outlined"
                            type="number"
                            value={displayOrder}
                            onChange={(e) => setDisplayOrder(e.target.value)}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {
                                    height: '56px',
                                    fontSize: '16px',
                                    padding: '8px 14px',
                                    backgroundColor: '#FFFFFF',
                                },
                            }}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#E0E0E0',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '16px',
                                },
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={<span>Platform Fee <span style={{ color: 'red' }}>*</span></span>}
                            fullWidth
                            variant="outlined"
                            type="number"
                            value={platformFee}
                            onChange={(e) => setPlatformFee(e.target.value)}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'},
                            }}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                                '& .MuiInputLabel-root': {fontSize: '16px'},
                            }}
                        />
                    </Grid>
                </Grid>

                <Box style={{ height: '20px' }} />

                {/* Commission Section */}
                <div style={{
                    marginBottom: '20px',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '8px',
                    backgroundColor: 'white',
                    maxWidth: '800px',
                    margin: '0 auto'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body1" style={{ fontWeight: 'bold' }}>Commission</Typography>
                    </div>
                    <Grid container spacing={2} style={{ marginTop: '20px' }}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label={<span>Commission Percentage <span style={{ color: 'red' }}>*</span></span>}
                                placeholder="Enter Percentage"
                                fullWidth
                                variant="outlined"
                                type="number"
                                value={commissionPercentage}
                                onChange={(e) => setCommissionPercentage(e.target.value)}
                                InputProps={{
                                    inputProps: { min: 0, max: 100 },
                                    style: {
                                        height: '50px',
                                        backgroundColor: '#F9F9F9',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label={<span>Commission Threshold <span style={{ color: 'red' }}>*</span></span>}
                                placeholder="Enter Threshold"
                                fullWidth
                                variant="outlined"
                                type="number"
                                value={commissionThreshold}
                                onChange={(e) => setCommissionThreshold(e.target.value)}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {
                                        height: '50px',
                                        backgroundColor: '#F9F9F9',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label={<span>Fixed Commission <span style={{ color: 'red' }}>*</span></span>}
                                placeholder="Enter Fixed Amount"
                                fullWidth
                                variant="outlined"
                                type="number"
                                value={fixedCommission}
                                onChange={(e) => setFixedCommission(e.target.value)}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {
                                        height: '50px',
                                        backgroundColor: '#F9F9F9',
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                </div>

                <Divider style={{ margin: '10px 0', visibility: 'hidden' }} />

                {/* Vehicle Request Radius Settings */}
                <div style={{
                    marginBottom: '20px',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '8px',
                    backgroundColor: 'white',
                    maxWidth: '800px',
                    margin: '0 auto'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body1" style={{ fontWeight: 'bold' }}>Vehicle Request Radius Settings</Typography>
                    </div>
                    <Grid container spacing={2} style={{ marginTop: '20px' }}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label={<span>Request Radius Threshold (in meters) <span style={{ color: 'red' }}>*</span></span>}
                                placeholder="Enter Threshold Radius"
                                fullWidth
                                variant="outlined"
                                type="number"
                                value={requestRadiusThreshold}
                                onChange={(e) => setRequestRadiusThreshold(e.target.value)}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {
                                        height: '50px',
                                        backgroundColor: '#F9F9F9',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label={<span>Initial Request Radius (in meters) <span style={{ color: 'red' }}>*</span></span>}
                                placeholder="Enter Initial Radius"
                                fullWidth
                                variant="outlined"
                                type="number"
                                value={initialRequestRadius}
                                onChange={(e) => setInitialRequestRadius(e.target.value)}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {
                                        height: '50px',
                                        backgroundColor: '#F9F9F9',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label={<span>Request Radius Hop <span style={{ color: 'red' }}>*</span></span>}
                                placeholder="Enter Radius Increment"
                                fullWidth
                                variant="outlined"
                                type="number"
                                value={requestRadiusHop}
                                onChange={(e) => setRequestRadiusHop(e.target.value)}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {
                                        height: '50px',
                                        backgroundColor: '#F9F9F9',
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                </div>

                <Divider style={{ margin: '10px 0', visibility: 'hidden' }} />

                {/* Taxes */}
                <div style={{
                    marginBottom: '20px',padding: '10px',border: '1px solid #ccc',borderRadius: '8px',
                    backgroundColor: 'white',maxWidth: '800px',margin: '0 auto'}}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body1" style={{ fontWeight: 'bold' }}>Taxes</Typography>
                    </div>
                    <Grid container spacing={2} style={{ marginTop: '20px' }}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label={<span>Tax Name <span style={{ color: 'red' }}>*</span></span>}
                                fullWidth variant="outlined" type="text"
                                value={taxName}
                                onChange={(e) => setTaxName(e.target.value)}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {height: '50px',backgroundColor: '#F9F9F9'}
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label={<span>Tax Percentage <span style={{ color: 'red' }}>*</span></span>}
                                fullWidth variant="outlined" type="number" value={taxPercentage}
                                onChange={(e) => setTaxPercentage(e.target.value)}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {height: '50px',backgroundColor: '#F9F9F9'}
                                }}
                            />
                        </Grid>
                    </Grid>
                </div>

                {/* Vehicle Type Images Section */}
                <div style={{
                    marginTop: '20px',
                    padding: '20px',
                    border: '1px solid #ccc',
                    borderRadius: '8px',
                    backgroundColor: 'white',
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                            Vehicle Type Image
                        </Typography>

                        <Button component="label"
                            sx={{
                                textTransform:'none',fontSize:'14px',backgroundColor:'#E0EBFF',color:'#0065FF',
                                display:'flex',alignItems: 'center',gap:'4px',minWidth: '100px',
                            }}
                            startIcon={<img src={addIcon} alt="Add" style={{ width: '16px', height: '16px' }} />}
                            disabled={images.length > 0}
                        >
                            Add Image
                            <input type="file" accept="image/*" hidden onChange={handleAddImage}/>
                        </Button>
                    </div>

                    {images.length > 0 && (
                        <Typography variant="body2" style={{ marginBottom: '10px' }}>
                            Uploaded Image
                        </Typography>
                    )}

                    <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                        {images.map((image, index) => (
                            <div key={index} style={{
                                padding: '10px',
                                border: '1px solid #D1D5DB',
                                borderRadius: '8px',
                                width: '150px',
                                textAlign: 'center',
                                backgroundColor: '#F9F9F9',
                            }}>
                                <img src={image.src} alt={image.name} style={{ width: '100%', borderRadius: '4px' }} />
                                <Typography variant="caption" style={{ display: 'block', marginTop: '5px' }}>{image.name}</Typography>
                                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '10px' }}>
                                    <Button
                                        variant="contained"
                                        onClick={() => handleViewImage(image)}
                                        sx={{
                                            minWidth: 0,
                                            padding: '6px',
                                            backgroundColor: '#1A1E25',
                                            '&:hover': {
                                                backgroundColor: '#1A1E25',
                                            },
                                        }}
                                    >
                                        <img src={eyeIcon} alt="View" style={{ width: '16px', height: '16px' }} />
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => handleDeleteImage(index)}
                                        sx={{
                                            minWidth: 0,
                                            padding: '6px',
                                            backgroundColor: '#C71F1F',
                                            '&:hover': {
                                                backgroundColor: '#C71F1F',
                                            },
                                        }}
                                    >
                                        <img src={binIcon} alt="Delete" style={{ width: '16px', height: '16px' }} />
                                    </Button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Modal for viewing the image */}
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="image-modal-title"
                    aria-describedby="image-modal-description"
                >
                    <Box sx={modalStyle}>
                        {currentImage && (
                            <img
                                src={currentImage.src}
                                alt={currentImage.name}
                                style={{ width: '100%', borderRadius: '8px' }}
                            />
                        )}
                    </Box>
                </Modal>


                {/* Submit and Reset Buttons */}
                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                    <Button variant="contained" color="primary" onClick={handleSubmit}
                        sx={{width:'140px',height:'50px',textTransform:'none',fontSize:'16px',backgroundColor:'#0065FF',color:'white'}}>
                        {editMode ? 'Update' : 'Save'}
                    </Button>
                    <Button variant="contained" onClick={onClose}
                        sx={{width:'140px',height:'50px',textTransform:'none',fontSize:'16px',backgroundColor: '#F0F0F0',color: '#B0B0B0'}}>
                        Cancel
                    </Button>
                </div>

            </Paper>

                
            {/* Documents Section */}
            <Paper elevation={3}
                style={{
                    padding: '30px', maxWidth: '800px', margin: '0 auto',backgroundColor: '#FFFFFF',borderRadius: '12px', marginTop:'3%'
                }}
            >
                
                {/* {editMode && ( */}
                    <>
                        <div style={{
                            marginBottom: '20px',
                            padding: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            backgroundColor: 'white',
                            maxWidth: '800px',
                            margin: '0 auto'
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography variant="body1" style={{ fontWeight: 'bold' }}>Documents</Typography>
                            </div>
                            <>
                                {documents.map((doc, index) => (
                                    <div key={index} style={{ marginTop: '20px', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px' }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    label={<span>Documents Name <span style={{ color: 'red' }}>*</span></span>}
                                                    fullWidth variant="outlined" value={doc.name}
                                                    onChange={(e) => handleDocumentChange(index, 'name', e.target.value)}
                                                    sx={{
                                                        '& .MuiInputBase-root': {
                                                            height: '50px',
                                                            backgroundColor: '#F9F9F9',
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField select
                                                    label={<span>Documents Type <span style={{ color: 'red' }}>*</span></span>}
                                                    fullWidth variant="outlined" value={doc.type}
                                                    onChange={(e) => handleDocumentChange(index, 'type', e.target.value)}
                                                    sx={{
                                                        '& .MuiInputBase-root': {
                                                            height: '50px',
                                                            backgroundColor: '#F9F9F9',
                                                        },
                                                    }}
                                                >
                                                    <MenuItem value="Image">Image</MenuItem>
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    label={<span>Number Of Images <span style={{ color: 'red' }}>*</span></span>}
                                                    fullWidth type="number" variant="outlined" value={doc.images}
                                                    onChange={(e) => handleDocumentChange(index, 'images', e.target.value)}
                                                    InputProps={{
                                                        inputProps: { min: 0 }, // Prevent values less than zero
                                                    }}
                                                    sx={{
                                                        '& .MuiInputBase-root': {
                                                            height: '50px',
                                                            backgroundColor: '#F9F9F9',
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>

                                        <div style={{
                                            display: 'flex',alignItems: 'center',justifyContent: 'space-between',marginTop: '20px',
                                            padding: '10px 20px',border: '1px solid #D1D5DB',borderRadius: '8px',backgroundColor: '#FFFFFF'
                                        }}>
                                            <Typography variant="body1" style={{ paddingLeft: '1px', color: '#4A4A4A'}}>
                                                Document No. Required <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Typography 
                                                    variant="body1"
                                                    style={{ marginRight: '8px' }}
                                                >
                                                    {doc.docNumberRequired ? 'Yes' : 'No'}
                                                </Typography>
                                                <IOSSwitch
                                                    checked={doc.docNumberRequired || false}
                                                    onChange={(e) => handleDocumentChange(index, 'docNumberRequired', e.target.checked)}
                                                />
                                            </div>
                                        </div>

                                        <div style={{
                                            display: 'flex',alignItems: 'center',justifyContent: 'space-between',marginTop: '20px',
                                            padding: '10px 20px',border: '1px solid #D1D5DB',borderRadius: '8px',backgroundColor: '#FFFFFF'
                                        }}>
                                            <Typography variant="body1" style={{ paddingLeft: '1px', color: '#4A4A4A'}}>
                                                Document Required <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Typography 
                                                    variant="body1"
                                                    style={{ marginRight: '8px' }}
                                                >
                                                    {doc.required ? 'Yes' : 'No'}
                                                </Typography>
                                                <IOSSwitch
                                                    checked={doc.required || false}
                                                    onChange={(e) => handleDocumentChange(index, 'required', e.target.checked)}
                                                />
                                            </div>
                                        </div>

                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                                        {doc.docId ? (
                                            <Button 
                                                onClick={
                                                    doc.isModified
                                                        ? () => handleUpdateDocument(index) // Update if modified
                                                        : () => handleDeleteDocument(index) // Delete if not modified
                                                }
                                                sx={{
                                                    textTransform:'none',fontSize:'14px',backgroundColor: doc.isModified ? '#0065FF' : '#FDE8E8',
                                                    color: doc.isModified ? 'white' : '#D14545',padding: '8px 16px',borderRadius: '8px',
                                                }}
                                            >
                                                {doc.isModified ? 'Update' : 'Delete'}
                                            </Button>
                                        ) : (
                                            <Button onClick={() => handleSaveNewDocument(index)}
                                                sx={{
                                                    textTransform: 'none',fontSize: '14px',backgroundColor: '#1A1E25',color: 'white',
                                                    padding: '8px 16px',borderRadius: '8px',
                                                }}
                                            >
                                                Save
                                            </Button>
                                        )}
                                        </div>
                                    </div>
                                ))}

                                <Button
                                    onClick={() =>
                                        setDocuments([
                                            ...documents,
                                            { name: '', type: '', images: 1, required: false, isModified: false, docNumberRequired: false },
                                        ])
                                    }
                                    sx={{
                                        marginTop:'10px',textTransform:'none',fontSize:'14px',backgroundColor:'#E0EBFF',
                                        color: '#0065FF',padding: '8px 16px',borderRadius: '8px'
                                    }}
                                >
                                    Add Document
                                </Button>
                            </>
                        </div>
                    </>
                {/* )} */}

            </Paper>

            {/* Vehicle Fare Settings Heading */}
            <Paper elevation={3}
                style={{
                    padding: '30px', maxWidth: '800px', margin: '0 auto',backgroundColor: '#FFFFFF',borderRadius: '12px', marginTop:'3%'
                }}
            >

                {/* {editMode && ( */}
                    <>
                        <Typography variant="h6" style={{marginBottom: '20px',fontWeight: 'bold',color: '#4A4A4A',fontSize: '20px'}}>
                            Vehicle Fare Settings
                        </Typography>

                        {/* Distance Fare */}
                        <div style={{marginBottom:'20px',padding: '10px',border:'1px solid #ccc',borderRadius:'8px',backgroundColor:'white',maxWidth: '800px',margin: '0 auto'}}>
                            
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'4%'}}>
                                <Typography variant="body1" style={{ fontWeight: 'bold' }}>Distance Fare</Typography>
                            </div>

                            {/* Base Fare and Minimum Fare */}
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Base Fare <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Base Fare"
                                        fullWidth
                                        variant="outlined"
                                        value={baseFare} // Set the value here
                                        onChange={(e) => setBaseFare(e.target.value)} // Add onChange handler to update state
                                        InputProps={{
                                            style: {
                                                height: '56px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#E0E0E0',
                                            },
                                            '& .MuiInputLabel-root': {
                                                fontSize: '16px',
                                                color: '#9E9E9E',
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Minimum Fare <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Minimum Fare"
                                        fullWidth
                                        variant="outlined"
                                        value={minimumFare} // Set the value here
                                        onChange={(e) => setMinimumFare(e.target.value)} // Add onChange handler to update state
                                        InputProps={{
                                            style: {
                                                height: '56px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#E0E0E0',
                                            },
                                            '& .MuiInputLabel-root': {
                                                fontSize: '16px',
                                                color: '#9E9E9E',
                                            },
                                        }}
                                    />
                                </Grid>
                            </Grid>

                            {/* Fare Threshold Section */}
                            <Typography
                                variant="body1"
                                style={{
                                    marginTop: '20px',
                                    fontWeight: 'bold',
                                    color: '#4A4A4A',
                                }}
                            >
                                Fare Threshold <span style={{ color: 'red' }}>*</span>
                            </Typography>

                            <div style={{
                                padding: '20px',
                                border: '1px solid #E0E0E0',
                                borderRadius: '8px',
                                backgroundColor: '#F9F9F9',
                                marginTop: '10px'
                            }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={5} sm={5}>
                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Distance (in km)</Typography>
                                    </Grid>
                                    <Grid item xs={5} sm={5}>
                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Price</Typography>
                                    </Grid>
                                </Grid>

                                {thresholds.map((threshold, index) => (
                                    <Grid container spacing={0} key={index} style={{ marginTop: '10px' }}>
                                        <Grid item xs={5} sm={5} style={{ paddingRight: 0 }}>
                                            <TextField
                                                placeholder="0"
                                                type="number"
                                                variant="outlined"
                                                fullWidth
                                                value={threshold.distance}
                                                onChange={(e) => handleThresholdChange(index, 'distance', e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {
                                                        height: '56px',
                                                        backgroundColor: '#FFFFFF',
                                                        borderRadius: '8px 0 0 8px', // Only round the left side
                                                        borderRight: 'none',
                                                    },
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={5} sm={5} style={{ paddingLeft: 0 }}>
                                            <TextField
                                                placeholder="0"
                                                type="number"
                                                variant="outlined"
                                                fullWidth
                                                value={threshold.price}
                                                onChange={(e) => handleThresholdChange(index, 'price', e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {
                                                        height: '56px',
                                                        backgroundColor: '#FFFFFF',
                                                        borderRadius: '0 8px 8px 0', // Only round the right side
                                                        borderLeft: 'none',
                                                    },
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            {index === thresholds.length - 1 ? (
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={handleAddThreshold}
                                                    startIcon={<PlusIcon />}
                                                    style={{
                                                        height: '56px',
                                                        color: '#0065FF',
                                                        borderColor: '#0065FF',
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        minWidth: '80px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    Add
                                                </Button>
                                            ) : (
                                                <Button
                                                    variant="outlined"
                                                    color="secondary"
                                                    onClick={() => handleRemoveThreshold(index)}
                                                    startIcon={<CloseIcon />}
                                                    style={{
                                                        height: '56px',
                                                        color: '#D14545',
                                                        borderColor: '#D14545',
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        minWidth: '80px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    Close
                                                </Button>
                                            )}
                                        </Grid>
                                    </Grid>
                                ))}
                            </div>

                        </div>

                        {/* Time Fare */}
                        <div style={{marginBottom:'20px',padding: '10px',border:'1px solid #ccc',borderRadius:'8px',backgroundColor:'white',maxWidth: '800px',margin: '0 auto', marginTop:'4%'}}>
                            
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'4%'}}>
                                <Typography variant="body1" style={{ fontWeight: 'bold' }}>Time Fare</Typography>
                            </div>

                            {/* Base Fare and Minimum Fare */}
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Base Fare <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Base Fare"
                                        fullWidth
                                        variant="outlined"
                                        value={timeBaseFare} // Set the value here
                                        onChange={(e) => setTimeBaseFare(e.target.value)} // Add onChange handler to update state
                                        InputProps={{
                                            style: {
                                                height: '56px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Minimum Fare <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Minimum Fare"
                                        fullWidth
                                        variant="outlined"
                                        value={minimumTimeFare} // Set the value here
                                        onChange={(e) => setMinimumTimeFare(e.target.value)} // Add onChange handler to update state
                                        InputProps={{
                                            style: {
                                                height: '56px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    />
                                </Grid>
                            </Grid>

                            {/* Fare Threshold Section */}
                            <Typography
                                variant="body1"
                                style={{
                                    marginTop: '20px',
                                    fontWeight: 'bold',
                                    color: '#4A4A4A',
                                }}
                            >
                                Fare Threshold <span style={{ color: 'red' }}>*</span>
                            </Typography>

                            <div style={{
                                padding: '20px',
                                border: '1px solid #E0E0E0',
                                borderRadius: '8px',
                                backgroundColor: '#F9F9F9',
                                marginTop: '10px'
                            }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={5} sm={5}>
                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Time (in minutes)</Typography>
                                    </Grid>
                                    <Grid item xs={5} sm={5}>
                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Price</Typography>
                                    </Grid>
                                </Grid>

                                {timeThresholds.map((threshold, index) => (
                                    <Grid container spacing={0} key={index} style={{ marginTop: '10px' }}>
                                        <Grid item xs={5} sm={5} style={{ paddingRight: 0 }}>
                                            <TextField
                                                placeholder="0"
                                                type="number"
                                                variant="outlined"
                                                fullWidth
                                                value={threshold.time}
                                                onChange={(e) => handleTimeThresholdChange(index, 'time', e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {
                                                        height: '56px',
                                                        backgroundColor: '#FFFFFF',
                                                        borderRadius: '8px 0 0 8px', // Only round the left side
                                                        borderRight: 'none',
                                                    },
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={5} sm={5} style={{ paddingLeft: 0 }}>
                                            <TextField
                                                placeholder="0"
                                                type="number"
                                                variant="outlined"
                                                fullWidth
                                                value={threshold.timePrice}
                                                onChange={(e) => handleTimeThresholdChange(index, 'timePrice', e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {
                                                        height: '56px',
                                                        backgroundColor: '#FFFFFF',
                                                        borderRadius: '0 8px 8px 0', // Only round the right side
                                                        borderLeft: 'none',
                                                    },
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            {index === timeThresholds.length - 1 ? (
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={handleAddTimeThreshold}
                                                    startIcon={<PlusIcon />}
                                                    style={{
                                                        height: '56px',
                                                        color: '#0065FF',
                                                        borderColor: '#0065FF',
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        minWidth: '80px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    Add
                                                </Button>
                                            ) : (
                                                <Button
                                                    variant="outlined"
                                                    color="secondary"
                                                    onClick={() => handleRemoveTimeThreshold(index)}
                                                    startIcon={<CloseIcon />}
                                                    style={{
                                                        height: '56px',
                                                        color: '#D14545',
                                                        borderColor: '#D14545',
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        minWidth: '80px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    Close
                                                </Button>
                                            )}
                                        </Grid>
                                    </Grid>
                                ))}
                            </div>

                        </div>

                        {/* Waiting Changes Window */}
                        <div style={{marginBottom:'20px',padding: '10px',border:'1px solid #ccc',borderRadius:'8px',backgroundColor:'white',maxWidth: '800px',margin: '0 auto', marginTop:'4%'}}>
                            
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'4%'}}>
                                <Typography variant="body1" style={{ fontWeight: 'bold' }}>Waiting Changes</Typography>
                            </div>

                            <Grid item xs={12} sm={12}>
                                <TextField
                                    label={<span>Waiting Charges Window <span style={{ color: 'red' }}>*</span></span>}
                                    fullWidth variant="outlined"
                                    value={waitingChangesWindow} // Set the value here
                                    onChange={(e) => setWaitingChangesWindow(e.target.value)} // Add onChange handler to update state
                                    InputProps={{
                                        style: {height: '56px',fontSize: '16px',padding:'8px 14px', backgroundColor: '#FFFFFF'}
                                    }}
                                />
                            </Grid>

                            {/* Fare Threshold Section */}
                            <Typography variant="body1" style={{marginTop: '20px',fontWeight: 'bold',color: '#4A4A4A'}}>
                                Waiting Changes Threshold <span style={{ color: 'red' }}>*</span>
                            </Typography>

                            <div style={{padding: '20px',border: '1px solid #E0E0E0',borderRadius: '8px',backgroundColor: '#F9F9F9',marginTop: '10px'}}>
                                <Grid container spacing={2}>
                                    <Grid item xs={2.5} sm={2.5}>
                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Min Time (in min)</Typography>
                                    </Grid>
                                    <Grid item xs={2.5} sm={2.5}>
                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Max Time (in min)</Typography>
                                    </Grid>
                                    <Grid item xs={2.5} sm={2.5}>
                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Charge</Typography>
                                    </Grid>
                                    <Grid item xs={2.5} sm={2.5}>
                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Driver Cut</Typography>
                                    </Grid>
                                </Grid>

                                {waitingThresholds.map((threshold, index) => (
                                    <Grid container spacing={0} key={index} style={{ marginTop: '10px' }}>
                                        <Grid item xs={2.5} sm={2.5} style={{ paddingRight: 0 }}>
                                            <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                // value={threshold.minDist}
                                                value={index === 0 ? Number(waitingChangesWindow)+1 : threshold.minDist}
                                                onChange={(e) => handleWaitingThresholdChange(index, 'minDist', e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '8px 0 0 8px',borderRight: 'none'},
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                            <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                value={threshold.maxDist}
                                                onChange={(e) => handleWaitingThresholdChange(index, 'maxDist', e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0',borderLeft: 'none'}
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                            <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                value={threshold.charge}
                                                onChange={(e) => handleWaitingThresholdChange(index, 'charge', e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0',borderLeft: 'none'}
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                            <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                value={threshold.driverCut}
                                                // onChange={(e) => handleWaitingThresholdChange(index, 'driverCut', e.target.value)}
                                                onChange={(e) => {
                                                    const value = Number(e.target.value);
                                                    if (value <= threshold.charge) {
                                                        handleWaitingThresholdChange(index, 'driverCut', value);
                                                    } else {
                                                        alert(`Driver Cut cannot exceed ${threshold.charge}`);
                                                    }
                                                }}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0 8px 8px 0',borderLeft: 'none'}
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            {index === waitingThresholds.length - 1 ? (
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={handleAddWaitingThreshold}
                                                    startIcon={<PlusIcon />}
                                                    style={{
                                                        height: '56px',
                                                        color: '#0065FF',
                                                        borderColor: '#0065FF',
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        minWidth: '80px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    Add
                                                </Button>
                                            ) : (
                                                <Button
                                                    variant="outlined"
                                                    color="secondary"
                                                    onClick={() => handleRemoveWaitingThreshold(index)}
                                                    startIcon={<CloseIcon />}
                                                    style={{
                                                        height: '56px',
                                                        color: '#D14545',
                                                        borderColor: '#D14545',
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        minWidth: '80px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    Close
                                                </Button>
                                            )}
                                        </Grid>
                                    </Grid>
                                ))}
                            </div>

                        </div>

                        {/* Luggage */}
                        <div style={{marginBottom:'20px',padding: '10px',border:'1px solid #ccc',borderRadius:'8px',backgroundColor:'white',maxWidth: '800px',margin: '0 auto', marginTop:'4%'}}>
                            
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'4%'}}>
                                <Typography variant="body1" style={{ fontWeight: 'bold' }}>Luggage</Typography>
                            </div>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Luggage Charges <span style={{ color: 'red' }}>*</span></span>}
                                        fullWidth
                                        variant="outlined"
                                        value={luggageCharges} // Set the value here
                                        onChange={(e) => setLuggageCharges(e.target.value)}
                                        InputProps={{
                                            style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Luggage Charges Driver Cut<span style={{ color: 'red' }}>*</span></span>}
                                        fullWidth
                                        variant="outlined"
                                        value={luggageChargesDriverCut} // Set the value here
                                        onChange={(e) => {
                                            const value = Number(e.target.value);
                                            if (value <= luggageCharges) {
                                                setLuggageChargesDriverCut(value);
                                            } else {
                                                alert(`Luggage Charges Driver Cut cannot exceed ${luggageCharges}`);
                                            }
                                        }}
                                        InputProps={{
                                            style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                        }}
                                    />
                                </Grid>
                            </Grid>

                        </div>

                        {/* Pickup Distance Window */}
                        <div style={{marginBottom:'20px',padding: '10px',border:'1px solid #ccc',borderRadius:'8px',backgroundColor:'white',maxWidth: '800px',margin: '0 auto', marginTop:'4%'}}>
                            
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'4%'}}>
                                <Typography variant="body1" style={{ fontWeight: 'bold' }}>Pickup Distance</Typography>
                            </div>

                            <Grid item xs={12} sm={12}>
                                <TextField
                                    label={<span>Pickup Distance Window <span style={{ color: 'red' }}>*</span></span>}
                                    fullWidth variant="outlined"
                                    value={pickupDistanceWindow} // Set the value here
                                    onChange={(e) => setPickupDistanceWindow(e.target.value)} // Add onChange handler to update state
                                    InputProps={{
                                        style: {height: '56px',fontSize: '16px',padding:'8px 14px', backgroundColor: '#FFFFFF'}
                                    }}
                                />
                            </Grid>

                            <Typography variant="body1" style={{marginTop: '20px',fontWeight: 'bold',color: '#4A4A4A'}}>
                                Pickup Distance Threshold <span style={{ color: 'red' }}>*</span>
                            </Typography>

                            <div style={{padding: '20px',border: '1px solid #E0E0E0',borderRadius: '8px',backgroundColor: '#F9F9F9',marginTop: '10px'}}>
                                <Grid container spacing={2}>
                                    <Grid item xs={2.5} sm={2.5}>
                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Min Distance (in km)</Typography>
                                    </Grid>
                                    <Grid item xs={2.5} sm={2.5}>
                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Max Distance (in km)</Typography>
                                    </Grid>
                                    <Grid item xs={2.5} sm={2.5}>
                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Charge</Typography>
                                    </Grid>
                                    <Grid item xs={2.5} sm={2.5}>
                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Driver Cut</Typography>
                                    </Grid>
                                </Grid>

                                {pickupThresholds.map((threshold, index) => (
                                    <Grid container spacing={0} key={index} style={{ marginTop: '10px' }}>
                                        <Grid item xs={2.5} sm={2.5} style={{ paddingRight: 0 }}>
                                            <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                value={index === 0 ? Number(pickupDistanceWindow)+1 : threshold.pickupMinDist}
                                                onChange={(e) => handlePickupThresholdChange(index, 'pickupMinDist', e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '8px 0 0 8px',borderRight: 'none'},
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                            <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                value={threshold.pickupMaxDist}
                                                onChange={(e) => handlePickupThresholdChange(index, 'pickupMaxDist', e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0',borderLeft: 'none'}
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                            <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                value={threshold.pickupCharge}
                                                onChange={(e) => handlePickupThresholdChange(index, 'pickupCharge', e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0',borderLeft: 'none'}
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                            <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                value={threshold.pickupDriverCut}
                                                // onChange={(e) => handlePickupThresholdChange(index, 'pickupDriverCut', e.target.value)}
                                                onChange={(e) => {
                                                    const value = Number(e.target.value);
                                                    if (value <= threshold.pickupCharge) {
                                                        handlePickupThresholdChange(index, 'pickupDriverCut', value);
                                                    } else {
                                                        alert(`Driver Cut cannot exceed ${threshold.pickupCharge}`);
                                                    }
                                                }}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0 8px 8px 0',borderLeft: 'none'}
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            {index === pickupThresholds.length - 1 ? (
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={handleAddPickupThreshold}
                                                    startIcon={<PlusIcon />}
                                                    style={{
                                                        height: '56px',
                                                        color: '#0065FF',
                                                        borderColor: '#0065FF',
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        minWidth: '80px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    Add
                                                </Button>
                                            ) : (
                                                <Button
                                                    variant="outlined"
                                                    color="secondary"
                                                    onClick={() => handleRemovePickupThreshold(index)}
                                                    startIcon={<CloseIcon />}
                                                    style={{
                                                        height: '56px',
                                                        color: '#D14545',
                                                        borderColor: '#D14545',
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        minWidth: '80px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    Close
                                                </Button>
                                            )}
                                        </Grid>
                                    </Grid>
                                ))}
                            </div>

                        </div>

                        {/* Save Button */}
                        {isFareModified && (
                            <Grid container justifyContent="center" style={{ marginTop: '20px' }}>
                                <Button
                                    variant="contained" color="primary" onClick={handleSaveFareSettings}
                                    style={{
                                        height: '56px',width: '800px', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#1A1E25',
                                        color: '#FFFFFF', textTransform: 'none', borderRadius: '8px', padding: '0 30px',
                                    }}
                                >
                                    Save
                                </Button>
                            </Grid>
                        )}
                    </>
                {/* )} */}
                
            </Paper>

            {/* Success/Failure Snackbar */}
            <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={() => setOpenSnackbar(false)}
                message={snackbarMessage}
                action={
                    <Button color="primary" size="small" onClick={() => setOpenSnackbar(false)}>
                        Close
                    </Button>
                }
            />
        </div>
    );
};

export default AddVehicle;